import { ChangeDetectionStrategy, Component, inject, input, model, signal } from '@angular/core';
import { OtapUpgradeTaskDTO, OtapUpgradeTaskInputParametersDTO } from '@app/shared/models/otap-upgrade-task.interface';
import { OtapUpgradeDTO } from '@app/shared/models/otap.upgrade.interface';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { OtapUpgradeService } from '@services/otap-upgrade/otap.upgrade.service';
import { ToastService } from '@services/toast/toast.service';
import { FormJobTaskComponent } from '../form-job-task/form-job-task.component';
import { JobTasksTileComponent } from '../job-tasks-tile/job-tasks-tile.component';

@Component({
  selector: 'app-job-tasks-summary',
  templateUrl: './job-tasks-summary.component.html',
  styleUrls: ['./job-tasks-summary.component.scss'],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatButton,
    MatCardContent,
    JobTasksTileComponent,
    FormJobTaskComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobTasksSummaryComponent {
  readonly task = input.required<OtapUpgradeTaskDTO>();
  readonly job = input.required<OtapUpgradeDTO>();
  readonly index = input.required<number>();
  readonly jobStartEnabled = model.required<boolean>();
  readonly updatedTaskData = signal<OtapUpgradeTaskInputParametersDTO[] | null>(null);
  readonly taskFormValid = signal<boolean>(false);
  private readonly otapUpgradeService = inject(OtapUpgradeService);
  private readonly toast = inject(ToastService);

  onTaskDataChanged(updatedData: OtapUpgradeTaskInputParametersDTO[]): void {
    this.updatedTaskData.set(updatedData);
  }

  onTaskFormValidityChanged(valid: boolean): void {
    this.taskFormValid.set(valid);
  }

  onSend(task: OtapUpgradeTaskDTO): void {
    const inputParameters = this.updatedTaskData() ?? task.inputParameters;
    this.otapUpgradeService.startTask(task.jobId, task.id, inputParameters).subscribe({
      next: (upgradetask) => {
        if (upgradetask !== null) {
          this.jobStartEnabled.set(false);
        }
      },
      error: (error) => {
        this.jobStartEnabled.set(true);
        this.toast.error({
          message: `${error.error}`,
          dataCy: 'task-cannot-be-started'
        });
      }
    });
  }
}
